
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"width":"38","height":"38","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h38v38H0z"}}),_c('path',{attrs:{"d":"M16.5 28V17m0 0V9.443a1 1 0 011.351-.936l8.152 3.057c.865.324.865 1.548 0 1.872L16.5 17zM20 24.2c4.078.48 7 1.776 7 3.3 0 1.933-4.701 3.5-10.5 3.5S6 29.433 6 27.5c0-1.46 2.685-2.713 6.5-3.237","stroke":"#000","stroke-width":"1.5","stroke-linecap":"round"}})])
      }
    
      }
    